import { IMapPosition, WithId } from 'transfix-maps/types'
import { TRACKING_POSITION_TYPES } from '../constants'
import { IActiveShipmentFragment } from '../graphql/ActiveShipmentFragment'
import { getTrackingType } from './getTrackingType'

interface IGetActiveShipmentsMapPositionsProps {
  activeShipments: IActiveShipmentFragment[]
}

export const getActiveShipmentsMapPositions = ({
  activeShipments,
}: IGetActiveShipmentsMapPositionsProps): WithId<IMapPosition>[] => {
  const shipments = activeShipments.filter(({ etaObject }) => etaObject)
  return shipments.map(shipment => {
    const { etaObject, id, trackingSummary } = shipment || {}
    const { lastPingLatitude, lastPingLongitude } = etaObject || {}
    const trackingType = getTrackingType({ etaObject, trackingSummary })
    return {
      id,
      type: TRACKING_POSITION_TYPES[trackingType],
      coords: {
        lat: lastPingLatitude || 0,
        lon: lastPingLongitude || 0,
      },
      data: {
        ...shipment,
      },
    }
  })
}
